import {
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Configs } from 'src/app/core/common/configs';
import { environment } from 'src/environments/environment';

@Injectable()
export class WithinKSAInterceptor implements HttpInterceptor {
  private configs = inject(Configs);
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<unknown> | HttpUserEvent<unknown>> {
    if (req.url === environment.url + '/api/configs') {
      return next.handle(req);
    }
    const request = req.clone({
      setHeaders: { 'within-ksa': (this.configs?.configs?.isInsideKSA ?? false).toString() },
    });
    return next.handle(request);
  }
}
